import { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Create script elements
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-0CG7CTN6B8';

    const configScript = document.createElement('script');
    configScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-0CG7CTN6B8');
    `;

    // Append scripts to document
    document.body.appendChild(gtagScript);
    document.body.appendChild(configScript);

    // Cleanup on unmount
    return () => {
      document.body.removeChild(gtagScript);
      document.body.removeChild(configScript);
    };
  }, []);

  return null;
};

export default GoogleAnalytics;